export const LEADERBOARD_TYPES = [
  { value: "ranked5v5", icon: "/icons/ranked" },
  { value: "ranked", icon: "/icons/ranked" },
  { value: "blitz", icon: "/icons/blitz" },
];

export const HEROES_TYPES = [
  { value: "pickRate", icon: "/icons/pickrate" },
  { value: "winRate", icon: "/icons/winrate" },
  { value: "banRate", icon: "/icons/banrate" },
];

export const REGIONS = ["all", "na", "eu", "ea", "sea", "sa", "cn"];

export default {
  LEADERBOARD_TYPES,
  REGIONS,
  HEROES_TYPES,
};
